// extracted by mini-css-extract-plugin
var _1 = "DocumentPreviewStyle-module__document-download___Hdp9U";
var _2 = "DocumentPreviewStyle-module__document-preview-filename___mNKxF";
var _3 = "DocumentPreviewStyle-module__document-download___Hdp9U";
var _4 = "DocumentPreviewStyle-module__document-preview-filename___mNKxF";
var _5 = "DocumentPreviewStyle-module__loader-wrapper___fdn9W";
var _6 = "DocumentPreviewStyle-module__loader-wrapper___fdn9W";
export { _1 as "document-download", _2 as "document-preview-filename", _3 as "documentDownload", _4 as "documentPreviewFilename", _5 as "loader-wrapper", _6 as "loaderWrapper" }
